import { useContext, useState, useEffect } from 'react';
import config from '@/config';

import { IssueContext } from '../Issue.context';
import { ReplicaContext } from './Replica.context';
import { SingleView } from './single/SingleView';
import { DoubleView } from './double/DoubleView';

import { useDownloadPages, isReplicaSupported } from './Replica.hooks';

const REPLICA_MODE_KEY = 'replica-mode-type';

export const ReplicaView = () => {
	const { issue, setMode } = useContext(IssueContext);

	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [viewMode, setViewMode] = useState<ReplicaModeType>(getDefaultMode());

	console.log(`Issue: `, issue);

	useDownloadPages({ issue });

	useEffect(() => {
		if (!issue) {
			return;
		}
		const isSupported = isReplicaSupported(issue);
		console.log(`Is replica supported: `, isSupported);
		if (!isSupported || config.issue.contentType === 'responsive') {
			setMode('responsive');
		}
	}, [issue]);

	useEffect(() => {
		localStorage.setItem(REPLICA_MODE_KEY, viewMode);
	}, [viewMode]);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	return (
		<ReplicaContext.Provider
			value={{
				isMenuOpen,
				setIsMenuOpen,
				toggleMenu,
				isSidebarOpen,
				setIsSidebarOpen,
				toggleSidebar,
				setViewMode,
			}}
		>
			{viewMode === 'single' ? (
				<SingleView
					issue={issue}
					onChangeResponsive={() => {
						setMode('responsive');
					}}
				/>
			) : (
				<DoubleView
					issue={issue}
					onChangeResponsive={() => {
						setMode('responsive');
					}}
				/>
			)}
		</ReplicaContext.Provider>
	);
};

function getDefaultMode(): ReplicaModeType {
	if (!localStorage.getItem(REPLICA_MODE_KEY)) {
		localStorage.setItem(REPLICA_MODE_KEY, 'single');
	}
	return localStorage.getItem(REPLICA_MODE_KEY) as ReplicaModeType;
}

type ReplicaModeType = 'single' | 'double';
